import categories from './categories';
import categoriesGridDesktop from './categoriesGridDesktop';
import categoriesGridMobile from './categoriesGridMobile';
import benefits from './benefits';
import banner from './banner';
import { leftBlock, rightBlock } from './catalogBanner';

import type { PageFrontendDTO } from '../typings';

const data: PageFrontendDTO = {
  banner: banner,
  rubrics: {
    header: 'Найти свое решение',
    description: 'Выбирайте интерьерные решения, которые подходят вам:',
    list: [
      {
        anchor: 'shkafy',
        title: 'Шкафы',
      },
      {
        anchor: 'komody-i-tumby',
        title: 'Комоды и тумбы',
      },
      {
        anchor: 'stellaji',
        title: 'Стеллажи',
      },
      {
        anchor: 'mebel-dlya-prihojey',
        title: 'Мебель для прхожей',
      },
    ],
  },
  categories: {
    shkafy: {
      hash: 'shkafy',
      link: '/category/promo-hranenie?types%5B%5D=62&types%5B%5D=51&types%5B%5D=121&types%5B%5D=376&types%5B%5D=38',
      coords: [[38, 19]],
      tiles: {
        desktop: categoriesGridDesktop[0],
        mobile: categoriesGridMobile[0],
      },
      image: categories[0],
    },
    'komody-i-tumby': {
      hash: 'komody-i-tumby',
      link: '/category/promo-hranenie?types%5B%5D=9&types%5B%5D=378&types%5B%5D=306&types%5B%5D=353&types%5B%5D=386&types%5B%5D=36&types%5B%5D=8&types%5B%5D=355&types%5B%5D=328&types%5B%5D=66&types%5B%5D=349&types%5B%5D=371',
      coords: [[73, 35]],
      tiles: {
        desktop: categoriesGridDesktop[1],
        mobile: categoriesGridMobile[1],
      },
      image: categories[1],
    },
    stellaji: {
      hash: 'stellaji',
      link: '/category/promo-hranenie?types%5B%5D=27&types%5B%5D=377&types%5B%5D=331',
      coords: [[25, 49]],
      tiles: {
        desktop: categoriesGridDesktop[2],
        mobile: categoriesGridMobile[2],
      },
      image: categories[2],
    },
    'mebel-dlya-prihojey': {
      hash: 'mebel-dlya-prihojey',
      link: '/category/promo-hranenie?types%5B%5D=94&types%5B%5D=359&types%5B%5D=361&types%5B%5D=41&types%5B%5D=362&types%5B%5D=32&types%5B%5D=354&types%5B%5D=39&types%5B%5D=58',
      coords: [
        [31, 48],
        [76, 59],
      ],
      tiles: {
        desktop: categoriesGridDesktop[3],
        mobile: categoriesGridMobile[3],
      },
      image: categories[3],
    },
  },
  catalog: {
    header: 'Вся мебель для хранения',
    text: '',
    button: {
      text: 'Перейти в каталог',
      link: '/category/promo-hranenie',
    },
    leftBlock: [
      { src: leftBlock[0], color: '#D8F0E2' },
      { src: leftBlock[1], color: '#D8F0E2' },
      { src: leftBlock[2], color: '#D8F0E2' },
    ],
    rightBlock: [
      { src: rightBlock[0], color: '#D8F0E2' },
      { src: rightBlock[1], color: '#D8F0E2' },
      { src: rightBlock[2], color: '#D8F0E2' },
    ],
  },
  benefits: [
    {
      image: benefits[0],
    },
    {
      image: benefits[1],
    },
    {
      image: benefits[2],
    },
    {
      image: benefits[3],
    },
  ],
};

export default data;
